import CollectionModule from 'client/store/modules/CollectionModule';
import SharedFolderGroupApi from 'client/api/v2/SharedFolderGroupApi';
import Vue from 'vue';

export const SharedFolderGroupCollection = (Api = SharedFolderGroupApi) => {
  const collection = new CollectionModule(Api, 'id', 'email');
  const sharedFolderGroupCollectionModule = collection.extractModule();

  const RESET_SHARED_FOLDER_GROUP = 'RESET_SHARED_FOLDER_GROUP';
  const SET_ACCESS_LEVELS = 'SET_ACCESS_LEVELS';
  const SET_SHARED_FOLDER_ID = 'SET_SHARED_FOLDER_ID';
  const UPDATE_REFRESH_KEY = 'UPDATE_REFRESH_KEY';

  const getInitialState = () => {
    const { state } = sharedFolderGroupCollectionModule;
    state.refreshKey = 0;
    state.accessLevels = [];
    state.accessLevelsLoaded = false;
    state.sharedFolderId = '';
    return state;
  };

  return {
    namespaced: true,

    state: getInitialState(),

    actions: {
      ...sharedFolderGroupCollectionModule.actions,

      async fetchAccessLevels({ commit }) {
        const resp = await SharedFolderGroupApi.fetchAccessLevels();
        commit(SET_ACCESS_LEVELS, resp.data.results);
        return resp;
      },

      resetSharedFoldersGroups({ commit }) {
        Api.setSharedFolderId('');
        commit(RESET_SHARED_FOLDER_GROUP);
        commit('RESET_COLLECTION');
      },

      async revokeAccessLevels({ dispatch }, groupId) {
        const resp = await SharedFolderGroupApi.delete(groupId);
        dispatch('updateRefreshKey');
        return resp;
      },

      setSharedFolderId({ commit }, sharedFolderId) {
        commit(SET_SHARED_FOLDER_ID, sharedFolderId);
        Api.setSharedFolderId(sharedFolderId);
      },

      async updateAccessLevel({ dispatch }, { groupId, accessLevelId }) {
        const resp = await SharedFolderGroupApi.updateGroupAccessLevel(groupId, accessLevelId);
        dispatch('updateRefreshKey');
        return resp;
      },

      updateRefreshKey(context) {
        context.commit(UPDATE_REFRESH_KEY);
      },
    },

    getters: {
      ...sharedFolderGroupCollectionModule.getters,

      accessLevels(state) {
        return state.accessLevels;
      },

      accessLevelsLoaded(state) {
        return state.accessLevelsLoaded;
      },

      refreshKey(state) {
        return state.refreshKey;
      },
    },

    mutations: {
      ...sharedFolderGroupCollectionModule.mutations,

      [SET_ACCESS_LEVELS](state, accessLevels) {
        Vue.set(state, 'accessLevels', accessLevels);
        Vue.set(state, 'accessLevelsLoaded', true);
      },

      [SET_SHARED_FOLDER_ID](state, sharedFolderId) {
        Vue.set(state, 'sharedFolderId', sharedFolderId);
      },

      [RESET_SHARED_FOLDER_GROUP](state) {
        const initialState = getInitialState();

        Vue.set(state, 'accessLevels', initialState.accessLevels);
        Vue.set(state, 'accessLevelsLoaded', initialState.accessLevelsLoaded);
        Vue.set(state, 'refreshKey', initialState.refreshKey);
        Vue.set(state, 'sharedFolderId', initialState.sharedFolderId);
      },

      [UPDATE_REFRESH_KEY](state) {
        Vue.set(state, 'refreshKey', state.refreshKey + 1);
      },
    },
  };
};

export default SharedFolderGroupCollection();
